<template>
  <div id="app">
    <div class="tg_box" v-if="isShow&&(pathName!='BoxRegister'&&pathName!='discount')">
      <left-menu :webLogo="webLogo" :companyName="companyName" :homeNav="nav" :serviceNav="serveList" :sysNav="sysList"
                 :datasNav="dataList" :cashNav="cashList" @cdr="clickDai"></left-menu>
      <div class="right_box">
        <div class="nav_box">
          <div class="nav">
            <!-- <div class="nav_left">
              <div class="nav_log_box" @click="jump(0, 'home')">
                <img class="logo_img" v-if="webLogo" :src="webLogo" alt="" srcset="">
                <div class="logo_word">{{companyName}}</div>
              </div>
              <div class="nav_wrapper">
                <div :class="['item', currentNav == k ? 'active_line' : '']" @click="jump(k, v.path)"
                  v-for="(v,k) in nav" :key="k">
                  {{ v.name }}
                </div>
              </div>
            </div> -->

            <div class="my_box">
              <!-- <div class="search_box">
                <el-input placeholder="请输入游戏名称" @blur="searchSuccess=false" @focus="searchSuccess=true"
                  @input="changeSearch" @keyup.enter.native="searchGame" v-model="keyword"></el-input>
                <i class="el-icon-search" style="cursor: pointer;" @click="searchGame"></i>
                <div class="search_suggest" v-show="suggestList.length>0&&keyword.length>0&&searchSuccess">
                  <div class="suggest_item" v-for="(item,index) in suggestList" :key="index"
                    @mousedown="jumpGame(item)">
                    <div class="suggest_name" :title="item.relation_game_name" v-html="item.game_name"></div>
                    <div class="suggest_suffix" v-if="item.game_suffix">
                      （<span v-html="item.game_suffix"></span>）
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="item">推广等级：<span style="color: #29d894;">{{ userInfo.promote_level_name }}</span></div>
              <div class="item">
                钱包：<span class="num_money">{{ userInfo.balance_profit }}</span>
              </div>
              <div class="item">
                平台币：<span class="num_money">{{ userInfo.balance_coin }}</span>
              </div>
              <div style="color: #8bb8f5;" class="charge" @click="$router.push({ name: 'platCharge' })">
                平台币充值
              </div>
              <div class="charge">
                <a style="color: #FF8484;text-decoration:none;" target="_blank"
                   href="https://pg.ttxgm.com/vip/uyas">APP助手</a>
              </div>

            </div>
            <div class="acc_info">
              <el-popover placement="bottom-end" popper-class="elepop" width="300" trigger="click">
                <div class="img_acc" slot="reference">
                  <img class="img" v-if="userInfo.head_img||webLogo" :src="
                      userInfo.unionid
                        ? userInfo.head_img
                        : webLogo
                    " alt="" srcset="" />
                  <div class="acc">{{ userInfo.account }}</div>
                  <i style="margin-left: 5px;color: #394d60;" class="el-icon-caret-bottom"></i>
                </div>
                <div class="my_pop_box">
                  <div class="pop_acc_head" style="display: flex;align-items: center;">
                    <img class="img" style="width: 40px;height: 40px;border-radius: 50%;" :src="userInfo.unionid
                        ? userInfo.head_img
                        : webLogo" alt="" srcset="" />
                    <div style="margin-left: 5px;" class="acc">
                      {{ userInfo.account }}
                    </div>
                  </div>
                  <div v-if="userInfo.mobile_phone" style="display: flex;margin-top: 10px;">
                    <div style="width: 100px;">当前登录手机</div>
                    <div>{{ userInfo.mobile_phone }}</div>
                  </div>
                  <div v-if="userInfo.unionid" style="display: flex;margin-top: 10px;">
                    <div style="width: 100px;">绑定微信号</div>
                    <div>{{ userInfo.nickname }}</div>
                  </div>
                  <div style="display: flex;margin-top: 10px;">
                    <div style="width: 100px;">渠道ID</div>
                    <div>{{ userInfo.id }}</div>
                  </div>
                  <div style="height: 1px;background: #e6edff;margin: 8px 0; "></div>
                  <div class="pop_item" @click="$router.push({ name: 'my' }, () => {})">
                    个人信息
                  </div>
                  <div class="pop_item" @click="dialogFeed=true">问题反馈</div>
                  <div class="pop_item" @click="$router.push({ name: 'problem' }, () => {})">常见问题</div>
                  <div class="pop_item" @click="logout">退出登录</div>
                </div>
              </el-popover>
            </div>
          </div>
          <div class="menu_recored">
            <div class="menu_box">
              <el-tabs v-model="currentMenu" type="card" @tab-remove="removeMenu" @tab-click="changeRoute">
                <el-tab-pane :closable="item.path=='/'?false:true" v-for="(item, index) in menuRecoredList"
                             :key="item.path" :label="item.title" :name="item.path">
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="main_box">
          <keep-alive :include="keepList">
            <router-view :key="key" />
          </keep-alive>
          <foot v-if="isShow&&(pathName!='BoxRegister'&&pathName!='discount')"></foot>
        </div>
      </div>
    </div>
    <div v-else>
      <keep-alive :include="keepList">
        <router-view :key="key" />
      </keep-alive>
    </div>

    <!-- <div style="height: 100px;" v-if="isShow&&(pathName!='BoxRegister'&&pathName!='discount')"></div> -->
    <!-- 问题反馈 -->
    <feed :dialogFeed.sync="dialogFeed"></feed>

    <!-- <img v-if="isShow&&(pathName!='BoxRegister'&&pathName!='discount')&&webLogo" v-drag id="drag"
      :class="['menu_img',dialogMenu?'rotate':'rotate_close']" @click="openMenu" :src="webLogo" alt="" srcset=""> -->

    <el-dialog title="" class="dia_menu" top="40px" :visible.sync="dialogMenu" width="820px">
      <div slot="title" class="dialog_title">
        <div>便捷应用</div>
        <div class="search_box">
          <div class="s_input">
            <el-input v-model="menuName" placeholder="请输入菜单名称" @input="menuSearch" clearable @blur="menuSuccess=false"
                      @focus="menuSuccess=true"></el-input>
            <div class="result_box" v-if="searchMenuList.length>0&&menuName.length>0&&menuSuccess">
              <div class="res_item" v-for="(item,index) in searchMenuList" :key="index"
                   @mousedown="(dialogMenu = false), menuName='',$router.push({ path: item.url })">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog_menu_box">
        <div class="menu_title_box">
          <div class="menu_title">服务应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in serveList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>

          </div>
        </div>
        <div class="menu_title_box">
          <div class="menu_title">系统应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in sysList" :key="k">
            <div class="dmenu_left" @click="jumpPage(v,k)">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
          </div>
        </div>
        <div class="menu_title_box">
          <div class="menu_title">数据应用</div>
        </div>
        <div class="dmenu_box">
          <div class="dmenu_item" v-for="(v, k) in dataList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
          </div>
        </div>
        <div class="menu_title_box" v-if="cashList.length>0">
          <div class="menu_title">提现管理</div>
        </div>
        <div class="dmenu_box" v-if="cashList.length>0">
          <div class="dmenu_item" v-for="(v, k) in cashList" :key="k">
            <div class="dmenu_left" @click="(dialogMenu = false), $router.push({ path: v.url })">
              <img class="dmenu_icon" :src="v.icon" alt="" srcset="" />
              <div class="dmenu_name">{{ v.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMenu = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- <div class="modal_div" v-if="showTip&&(pathName!='BoxRegister'&&pathName!='discount')">
      <div class="menu_tip">点我可切换菜单</div>
    </div> -->
    <!-- 代充方式 -->
  </div>
</template>

<script>
  import {
    getUser
  } from "@/api/login";
  import {
    gameList,
  } from "@/api/extension";
  import {
    mapGetters
  } from "vuex";
  import {
    get_customize_config
  } from "@/api/my";
  import feed from '@/component/my/feed_back.vue'
  import {
    serveList,
    sysList,
    dataList,
    cashList
  } from "@/utils/menu";
  import foot from '@/component/foot.vue'
  import leftMenu from '@/component/left_menu.vue'
  let windowWidth = window.innerWidth
  let windowHeight = window.innerHeight
  let IMGURL = 0
  export default {
    name: "App",
    data() {
      return {
        currentNav: 0,
        keyword: '',
        dialogFeed: false,
        nav: [{
            name: '主页',
            path: 'home',
            url: '/'
          },
          {
            name: '混服推广',
            path: 'extension',
            url: '/index/extension'
          },
          {
            name: '专服绿色服推广',
            path: 'zf_zone',
            url:'/index/zf_zone'
          },
          {
            name: '排名',
            path: 'datas',
            url: '/index/datas'
          },
          {
            name: '盒子',
            path: 'box',
            url: '/index/box'
          },
          {
            name: '个人信息',
            path: 'my',
            url: '/index/my'
          },

        ],
        isShow: false,
        suggestList: [],
        searchSuccess: false,
        keepList: ['my', 'home', 'extension', 'datas', 'box', 'activeSearch'],
        dialogMenu: false,
        dataList: dataList,
        cashList: [],
        serveList: serveList,
        sysList: sysList,
        dialogModal: false,
        isMove: false,
        first: localStorage.getItem('first'),
        pathName: '',
        webLogo: '', //https://ttxres.ttxgm.com/site/20240319/160d17948e06a0360b5f733f4ded7cca.png
        companyLogo: '',
        companyName: '凸凸虾游戏',
        menuRecoredList: [{
          title: '首页',
          path: '/',
          name: 'home'
        }],
        currentMenu: '/',
        menuName: '',
        searchMenuList: [],
        menuSuccess: false,
        dialogBack: false,
        dialogPro: false,
        dialogInner: false,
      };
    },
    // 自定义指令 —— 拖动div
    directives: {
      drag(el) {
        let oDiv = el // 当前元素
        // let self = this // 上下文
        // 禁止选择网页上的文字
        // document.onselectstart = function() {
        //   return false
        // }
        let firstTime = '',
          lastTime = '';
        // let [maxWidth, maxHeight] = [windowWidth - 76, windowHeight - 70]
        oDiv.onmousedown = function(e) {
          document.getElementById('drag').setAttribute('data-flag', false)
          firstTime = new Date().getTime();
          // 鼠标按下，计算当前元素距离可视区的距离
          let disX = e.clientX - oDiv.offsetLeft
          let disY = e.clientY - oDiv.offsetTop
          document.onmousemove = function(e) {
            // 76 70
            // IMGURL

            // var img = new Image()
            // img.src = IMGURL
            let [maxWidth, maxHeight] = [windowWidth - 76, windowHeight - 70]
            // 通过事件委托，计算移动的距离
            let l = e.clientX - disX
            let t = e.clientY - disY

            if (l >= maxWidth) {
              l = maxWidth
            }
            if (l <= 0) {
              l = 0
            }
            if (t >= maxHeight) {
              t = maxHeight
            }
            if (t <= 0) {
              t = 0
            }
            // 移动当前元素
            oDiv.style.left = l + 'px'
            oDiv.style.top = t + 'px'
          }
          //鼠标抬起事件
          document.onmouseup = function(e) {
            document.onmousemove = null
            document.onmouseup = null
            lastTime = new Date().getTime();
            if ((lastTime - firstTime) < 200) {
              document.getElementById('drag').setAttribute('data-flag', true)
            }
          }
          // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
          return false
        }
      }
    },
    components: {
      feed,
      foot,
      leftMenu,
    },
    computed: {
      ...mapGetters(["userInfo"]),
      showTip() {
        return this.isShow && !this.first
      },
      key() {
        return this.$route.fullPath
      }
    },
    watch: {
      $route(to, from) {
        this.pathName = to.name
        if (to.name == 'login') {
          this.isShow = false
          this.keepList = []
          this.nav = [{
              name: '主页',
              path: 'home',
              url:'/'
            },
            {
              name: '推广',
              path: 'extension',
              url:'/index/extension'
            },
            {
              name: '专服绿色服推广',
              path: 'zf_zone',
              url: '/index/zf_zone',
            },
            {
              name: '排名',
              path: 'datas',
              url:'/index/datas'
            },
            {
              name: '盒子',
              path: 'box',
              url:'/index/box'
            },
            {
              name: '个人信息',
              path: 'my',
              url:'/index/my'
            },
          ]
          let threeIndex = this.serveList.findIndex((v) => {
            return v.id == 28
          })
          if (threeIndex >= 0) {
            this.serveList.splice(threeIndex, 1)
          }
          this.menuRecoredList = [{
            title: '首页',
            path: '/',
            name: 'home',
            url: '/'
          }]

        } else {
          if (to.name == 'BoxRegister') {
            document.title = '玩家注册-凸凸虾游戏'
          }
          this.isShow = true
          if (to.name == 'home') {
            this.currentMenu = '/'
          } else {
            this.currentMenu = to.fullPath
          }

          if (to.name != 'home') {

            let menuTitle = ''
            if (to.name == 'rechargeList') {
              if (to.query.type == '0.1') {
                menuTitle = '0.1折充值明细'
              } else {
                menuTitle = '玩家充值'
              }

            } else if (to.name == 'commissionDetail') {
              if (to.query.type == 'commission') {
                menuTitle = '佣金明细'
              } else if (to.query.type == 'plat') {
                menuTitle = '平台币明细'
              } else if (to.query.type == 'deposit') {
                menuTitle = '押金明细'
              } else {
                menuTitle = '积分明细'
              }

            } else {
              menuTitle = to.meta.title
            }
            let isAdd = this.menuRecoredList.some(v => {
              return v.path == to.fullPath
            })

            if (!isAdd) {
              if (menuTitle && to.name) {
                this.menuRecoredList.push({
                  title: menuTitle,
                  path: to.fullPath,
                  name: to.name
                })
              } else {
                this.currentMenu = '/'
              }

            }

          }
        }
        if (from.name == 'login') {
          this.keepList = ['my', 'home', 'extension', 'datas', 'box', 'activeSearch']
        }
        window.scrollTo(0, 0)
        if (to.name != 'extension') {
          this.keyword = ''
        }
        switch (to.name) {
          case "home":
            this.currentNav = 0;
            break;
          case "extension":
            this.currentNav = 1;
            break;
          case "zf_zone":
            this.currentNav = 2;
            break;
          case "datas":
            this.currentNav = 3;
            break;
          case "box":
            this.currentNav = 4;
            break;
          case "my":
            this.currentNav = 5;
            break;
          case "oem":
            this.currentNav = 6;
            break;
          default:
            this.currentNav = null;
        }
      },

    },
    mounted() {
      // window.addEventListener("beforeunload", () => {
      //   getUser().then(res => {
      //     console.log(res)
      //     this.$store.dispatch("getUserInfo", res.data)
      //   })
      //   console.log('刷新了')
      // })
      // console.log(window.innerHeight, document.documentElement.clientHeight, document.body.clientHeight)
      // console.log(document.querySelector("link[rel*='icon']"))
      // document.querySelector("link[rel*='icon']").href = 'https://img.guopan.cn/cp_upload/GP1647848530_547.png'
      // document.title = '一拳超人:最强之男'
      let timer = null
      window.addEventListener('resize', () => {
        // 节流
        if (!timer) {
          timer = setTimeout(() => {
            timer = null;
            windowWidth = window.innerWidth
            windowHeight = window.innerHeight
          }, 1000)
        }
      })

      let token = localStorage.getItem('token')
      if (token) {
        getUser().then(res => {
          if (res.code == 200) {
            this.$store.dispatch("getUserInfo", res.data);

            if (res.data.promote_level == 1) {
              this.nav.push({
                name: '品牌打造',
                path: 'oem',
                url: '/index/oem'
              })

              let isQu = this.serveList.some(v => {
                return v.id == 6;
              });
              if (!isQu) {
                this.serveList.push({
                  name: "渠道管理",
                  icon: "https://ttxres.ttxgm.com/promote_zs_static/promote_edit.png",
                  url: "/home/son_list",
                  id: 6,
                  show: false
                });
              }
              // let isBu = this.sysList.some(v => {
              //   return v.id == 22;
              // });
              // if (!isBu) {
              //   this.sysList.push({
              //     name: "游戏补点",
              //     icon: "https://ttxres.ttxgm.com/promote_zs_static/game_bu.png",
              //     url: "/home/bu_dot",
              //     id: 22,
              //     show: false
              //   });
              // }
              let isDeposit = this.sysList.some(v => {
                return v.id == 19;
              });
              // if (!isDeposit) {
              //   this.sysList.push({
              //     name: '下级提现',
              //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/lower_cash.png',
              //     url: '/home/lower_cash',
              //     id: 19,
              //     show: false
              //   })
              // }
              let isJie = this.sysList.some(v => {
                return v.id == 20;
              });
              // if (!isJie) {
              //   this.sysList.push({
              //     name: '下级结算',
              //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/lower_final.png',
              //     url: '/home/lower_final',
              //     id: 20,
              //     show: false
              //   })
              // }

              // let isBrecored = this.dataList.some(v => {
              //   return v.id == 23;
              // });
              // if (!isBrecored) {
              //   this.dataList.push({
              //     name: "补点记录",
              //     icon: "https://ttxres.ttxgm.com/promote_zs_static/bu_recored.png",
              //     url: "/home/dot_recored",
              //     id: 23,
              //     show: false
              //   });
              // }
              // let isTotal = this.dataList.some(v => {
              //   return v.id == 21;
              // });
              // if (!isTotal) {
              //   this.dataList.push({
              //     name: '结算汇总',
              //     icon: 'https://ttxres.ttxgm.com/promote_zs_static/final_total.png',
              //     url: '/home/final_total',
              //     id: 21,
              //     show: false
              //   })
              // }

            }
            let isThreeGame = this.serveList.some(v => {
              return v.id == 28;
            });
            if (!isThreeGame && res.data.is_third_game) {
              this.serveList.push({
                name: "第三方游戏",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/bu_recored.png",
                url: "/mine/three_game",
                id: 28,
                show: false
              });
            }
            let isBackPtb = this.sysList.some(v => {
              return v.id == 34;
            })
            if (!isBackPtb && res.data.can_ptb_recovery) {
              this.sysList.push({
                name: "平台币收回",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/daicc.png",
                url: "/mine/substitute_back",
                id: 34,
                show: false
              });
            }
            if (res.data.is_third_game == 0) {
              let threeIndex = this.serveList.findIndex((v) => {
                return v.id == 28
              })
              if (threeIndex >= 0) {
                this.serveList.splice(threeIndex, 1)
              }
            }
            let cashRole = res.data.trade_limit
            switch (cashRole) {
              case 1:
                this.cashList = [{
                    name: "余额发布列表",
                    icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_detail.png",
                    url: "/mine/sum_list",
                    id: 29,
                    show: false
                  },
                  {
                    name: "余额购买记录",
                    icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_detail.png",
                    url: "/mine/money_buy_record",
                    id: 30,
                    show: false
                  }
                ];
                break;
              case 2:
                this.cashList = [{
                  name: "余额提现",
                  icon: "https://ttxres.ttxgm.com/promote_zs_static/commission_t.png",
                  url: "/mine/cash",
                  id: 7,
                  show: false
                }];
                break;
              case 3:
                this.cashList = cashList;
                break;
              default:
                this.cashList = [];
            }
            let playerRule = res.data.recharge_user_ptb
            if (playerRule == 1) {
              this.dataList.push({
                name: "平台币代充记录",
                icon: "https://ttxres.ttxgm.com/promote_zs_static/user_login_record.png",
                url: "/mine/playerplat_list",
                id: 31,
                show: false
              })
            }
          }
          // require("@/assets/user_select.png")
        })
        get_customize_config().then(res => {
          if (res.code == 200) {
            if (res.data.pc.union_set) {
              let data = res.data.pc.union_set
              if (this.$route.name != 'BoxRegister') {
                document.title = data.site_name || '凸凸虾游戏混服推广后台'
              }
              document.querySelector("link[rel*='icon']").href = data.pc_icon ||
                'https://ttxres.ttxgm.com/promote_zs_static/icon_font.png'
              this.companyName = data.company_name || '凸凸虾游戏'
              this.webLogo = data.website_logo ||
                'https://ttxres.ttxgm.com/static/login_left.png'
              this.companyLogo = data.website_logo || require("@/assets/index_head.png")
            } else {
              this.companyName = '凸凸虾游戏'
              this.webLogo =
                'https://ttxres.ttxgm.com/static/login_left.png'
              this.companyLogo = require("@/assets/index_head.png")
            }
          }
        })
      } else {
        setTimeout(() => {
          if (this.$route.name != 'BoxRegister') {
            document.title = '凸凸虾游戏混服推广后台'
          }
        }, 1500)
      }
      let index = window.location.href.lastIndexOf('/')
      let pathName = window.location.href.substring(index + 1)
      if (pathName != 'login') {
        this.isShow = true
      }
      pathName = pathName == '' ? '/' : pathName == '?type=login' ? '/' : pathName
      switch (pathName) {
        case "/":
          this.currentNav = 0;
          break;
        case "extension":
          this.currentNav = 1;
          break;
        case "datas":
          this.currentNav = 2;
          break;
        case "my":
          this.currentNav = 4;
          break;
        case "box":
          this.currentNav = 3;
          break;
        case "oem":
          this.currentNav = 5;
          break;
        default:
          this.currentNav = null;
      }
    },
    methods: {
      clickDai() {
        if ((this.userInfo.is_admin == 1 || this.userInfo.is_admin == 2) && this.userInfo.promote_level == 1) {
          this.dialogModal = true;
        } else if (this.userInfo.promote_level != 1 && this.userInfo.is_surcharge != 1) {
          this.$message({
            message: "暂未开放",
            type: "warning"
          });
        } else {
          this.$router.push({
            path: "/home/substitute"
          });
        }
      },
      menuSearch(v) {
        this.searchMenuList = []
        this.$tools.debounce(() => {
          if (v.length > 0) {
            let arr = []
            let allMenu = [...this.serveList, ...this.sysList, ...this.dataList, ...this.cashList]
            for (let i = 0; i < allMenu.length; i++) {
              if (allMenu[i].name.indexOf(this.menuName) >= 0) {
                arr.push(allMenu[i])
              }
            }
            this.searchMenuList = arr
            this.menuSuccess = true
          }
        }, 600)()
      },
      removeMenu(targetName) {
        let tabs = this.menuRecoredList;
        let activeName = this.currentMenu;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.path === targetName) {
              let preTab = tabs[index - 1];
              if (preTab) {
                activeName = preTab.path;
              }
            }
          });
        }
        this.currentMenu = activeName;
        this.$router.push({
          path: activeName
        });
        this.menuRecoredList = tabs.filter(tab => tab.path !== targetName);
      },
      changeRoute(v) {
        // console.log(v.$router.currentRoute.name)
        this.$router.push({
          path: v.name,
        });

      },
      openMenu() {
        let isClick = document.getElementById('drag').getAttribute('data-flag');
        if (isClick == 'true') {
          this.dialogMenu = !this.dialogMenu
          let first = localStorage.getItem('first')
          if (!first) {
            localStorage.setItem('first', 1)
          }
          if (!this.first) {
            this.first = 1
          }
        }
      },
      jumpPage(v, k) {
        this.dialogMenu = false
        this.$router.push({
          path: v.url
        })
      },
      jumpGame(item) {
        let extensionIndex = this.menuRecoredList.findIndex((v) => {
          return v.name == 'extension'
        })
        if (extensionIndex > 0) {
          this.menuRecoredList.splice(extensionIndex, 1)
        }
        this.$router.push({
          name: 'extension',
          query: {
            keyword: item.game_id,
            type: 'topSearch'
          }
        }, () => {})
      },
      changeSearch(v) {
        if (v.length == 0) {
          this.suggestList = []
        }
        this.$tools.debounce(() => {
          let params = {
            page: 1,
            limit: 10,
            game_name: v
          }
          if (v.length > 0) {
            gameList('/game/all_game', params).then(res => {
              if (res.code == 200) {
                this.suggestList = res.data
                this.searchSuccess = true
                res.data.forEach(item => {
                  item.game_name = this.hightLightText(item.relation_game_name, v)
                  item.game_suffix = this.hightLightText(item.game_suffix, v)
                })
              }
            });
          }
        }, 600)()
      },
      hightLightText(text, keyWord) {
        if (text) {
          var reg = new RegExp(keyWord, "gi");
          var newstr = text.replace(reg, `<span style="color:red;">${keyWord}</span>`);
          return newstr;
        } else return text;
      },
      jump(k, path) {
        // if (path == 'zf_zone') {
        //   window.open("https://ttxgm.com/zf");
        //   return
        // }
        if (this.$route.name == 'extension' && path == 'extension') {
          return
        }
        let extensionIndex = this.menuRecoredList.findIndex((v) => {
          return v.name == 'extension'
        })
        if (extensionIndex > 0 && path == 'extension') {
          this.menuRecoredList.splice(extensionIndex, 1)
        }
        this.currentNav = k;
        this.$router.push({
          name: path
        });
      },
      jumpIp(url) {
        window.open(url, '_blank');
      },
      searchGame() {
        let extensionIndex = this.menuRecoredList.findIndex((v) => {
          return v.name == 'extension'
        })
        if (extensionIndex > 0) {
          this.menuRecoredList.splice(extensionIndex, 1)
        }
        this.$router.replace({
          name: 'extension',
          query: {
            keyword: this.keyword,
            type: 'search'
          }
        }, () => {})
      },
      logout() {
        localStorage.removeItem("token");
        let adminUser = localStorage.getItem('adminUser')
        if (adminUser) {
          localStorage.removeItem('adminUser')
        }
        this.$router.push({
          name: "login"
        });
      }
    }
  };
</script>
<style lang="less">
.elepop {
  .my_pop_box {

    // width: 200px;
    .pop_acc_head {
      display: flex;

      .img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      .acc {
        margin-left: 5px;
        color: #394d60;
      }
    }

    .pop_item {
      height: 30px;
      line-height: 30px;
      cursor: pointer;

      &:hover {
        color: #29d894;
        background: #f3f6f5;
      }
    }
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  /* will-change属性可以提前通知浏览器我们要对元素做什么动画，这样浏览器可以提前准备合适的优化设置 */
  will-change: transform;
  transition: all ease 1.8s;
  -webkit-transition: all ease 1.8s;
  position: absolute;
  width: 100%;
  left: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}

.slide-right-leave-active {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.slide-left-enter {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.slide-left-leave-active {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}
</style>
<style lang="less" scoped>
#app {
  font-family: 'puhui';
  -webkit-user-select: text !important;

  .menu_recored {
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;


    .menu_box {
      background-color: white;
      max-width: calc(100vw - 241px);
      margin-top: 10px;

      // margin-bottom: 20px;
    }

    /deep/ .el-tabs__header {
      margin: 0;
    }

    /deep/ .el-tabs__item {
      border-bottom: none;
      height: 30px;
      line-height: 30px;
    }

    /deep/ .el-tabs__nav-next,
    /deep/ .el-tabs__nav-prev {
      line-height: 30px;
    }
  }

  .main_box::-webkit-scrollbar {
    display: none;
  }

  .main_box {
    height: calc(100vh - 101px);
    overflow: auto;
    padding: 20px 20px 0;
    box-sizing: border-box;
    width: calc(100vw - 201px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    -ms-overflow-style: none;
    /* IE和Edge浏览器 */
    scrollbar-width: none;
  }

  .nav_box {
    display: flex;
    flex-direction: column;
    // align-items: center;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    width: calc(100vw - 201px);


    .nav {
      display: flex;
      flex-shrink: 0;
      justify-content: space-between;
      height: 60px;
      align-items: center;
      flex-wrap: nowrap;
      padding: 0 20px;
      box-sizing: border-box;

      .nav_left {
        display: flex;


      }

      .nav_log_box {
        display: flex;
        align-items: center;
        width: 150px;
        cursor: pointer;

        .logo_img {
          width: 40px;
          height: 40px;
        }

        .logo_word {
          font-size: 16px;
          font-weight: 700;
          color: #29D894;
          margin-left: 10px;
        }
      }

      .nav_wrapper {
        display: flex;
        height: 60px;
        align-items: center;

        .item {
          font-weight: bold;
          // font-family: '"Microsoft YaHei';
          // font-family: "Helvetica Neue";
          font-size: 14px;
          position: relative;
          cursor: pointer;
          // margin-left: 20px;
          letter-spacing: 2px;
          height: 60px;
          line-height: 60px;
          padding: 0 15px;
          box-sizing: border-box;
          color: #394d60;

          &:hover {
            background-color: #e9f1f5;

            &::after {
              // left: 10%;
              // transition: all .8s ease-out;
              // width: 80%;

              content: "";
              width: 100%;
              height: 2px;
              background-color: #29d894;
              position: absolute;
              bottom: 0;
              left: 0;

            }
          }

          &:first-child {
            margin-left: 0;
          }

          // &::after {
          //   content: "";
          //   width: 0;
          //   height: 3px;
          //   background-color: #29d894;
          //   position: absolute;
          //   top: 110%;
          //   left: 50%;
          //   transition: all .8s ease-out;
          // }
        }

        .active_line {
          // color: #29d894;
          background-color: #e9f1f5;

          &::after {
            // left: 10%;
            // transition: all .8s ease-out;
            // width: 80%;

            content: "";
            width: 100%;
            height: 2px;
            background-color: #29d894;
            position: absolute;
            bottom: 0;
            left: 0;

          }
        }
      }

      .acc_info {
        .img_acc {
          display: flex;
          align-items: center;
          margin-left: 10px;
          position: relative;
          cursor: pointer;

          .img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }

          .acc {
            margin-left: 5px;
            color: #394d60;
          }
        }
      }

      .my_box {
        display: flex;
        align-items: center;

        .search_box {
          display: flex;
          border: 1px solid #e9f1f5;
          height: 40px;
          border-radius: 40px;
          align-items: center;
          margin-right: 10px;
          padding: 0 15px;
          position: relative;
          box-sizing: border-box;

          /deep/ .el-input__inner {
            border: none;
            height: 30px;
            padding-left: 0;
          }

          .search_suggest {
            position: absolute;
            z-index: 99;
            left: 0;
            top: 48px;
            background-color: white;
            border: 1px solid #e9f1f5;
            border-radius: 3px;
            max-height: 200px;
            overflow-y: scroll;
            width: 233px;
            box-sizing: border-box;
            padding: 0 3px 0 10px;
            box-sizing: border-box;
            padding-bottom: 10px;

            .suggest_item {
              display: flex;
              align-items: center;
              color: #394d60;
              font-size: 14px;
              margin-top: 10px;
              cursor: pointer;


              .suggest_name {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .suggest_suffix {
                flex-shrink: 0;
              }
            }
          }
        }

        .item {
          margin-right: 10px;

          .num_money {
            font-family: 'font';
          }
        }

        .charge {
          color: #29d894;
          margin-right: 10px;
          cursor: pointer;
        }


      }
    }
  }
}

.menu_img {
  position: fixed;
  top: 300px;
  right: 50px;
  z-index: 9999;
  cursor: pointer;
  width: 68px;
  height: 68px;
}

.rotate {
  animation: fadenum .8s forwards;
  // transform: rotate(180deg);
}

@keyframes fadenum {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(180deg);
  }
}

.rotate_close {
  animation: fadenum_close .8s forwards;
}

@keyframes fadenum_close {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.dialog_menu_box {
  .menu_title_box {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: baseline;

    .menu_title {
      position: relative;
      margin-top: 20px;

      &:before {
        content: "";
        position: absolute;
        left: -20px;
        height: 20px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        background-color: #29d894;
        border-radius: 4px;
      }
    }

    .title_tip {
      font-size: 13px;
      margin-left: 5px;
      font-weight: normal;
    }
  }

  .dmenu_box {
    display: flex;
    flex-wrap: wrap;

    .dmenu_item {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f8f9fd;
      border-radius: 5px;
      padding: 5px 10px;
      box-sizing: border-box;
      width: 180px;
      margin-right: 15px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .dmenu_left {
        display: flex;
        font-size: 14px;
        align-items: center;
        flex: 1;

        .dmenu_icon {
          width: 35px;
          height: 35px;
        }

        .dmenu_name {
          margin-left: 5px;
        }
      }
    }
  }
}

.dia_menu {
  /deep/ .el-dialog__body {
    padding: 0 20px 20px;
  }
}

.modal_div {
  width: 100vw;
  height: 100vh;
  background-color: #00000080;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;

  .menu_tip {
    border: 1px dashed #fff;
    border-radius: 30px;
    padding: 5px 20px;
    position: fixed;
    top: 260px;
    right: 20px;
    font-size: 14px;
    z-index: 100000;
  }
}

.dialog_title {
  display: flex;
  align-items: center;

  .search_box {
    // margin-top: 20px;
    margin-left: 30px;
    display: flex;
    align-items: center;

    .s_input {
      position: relative;

      .result_box {
        position: absolute;
        z-index: 99;
        left: 0;
        top: 45px;
        background-color: white;
        border: 1px solid #e9f1f5;
        border-radius: 3px;
        width: 217px;
        box-sizing: border-box;

        .res_item {
          height: 30px;
          line-height: 30px;
          padding-left: 17px;
          cursor: pointer;

          &:hover {
            background-color: #a9efd4;
          }
        }
      }
    }
  }
}

.tg_box {
  display: flex;

  .right_box {}
}

.modal_box {
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn {
    width: 200px;
    height: 40px;
    border-radius: 40px;
    font-size: 16px;
    color: white;
    text-align: center;
    line-height: 40px;
    margin-top: 15px;
    cursor: pointer;

    &:first-child {
      margin-top: 0;
    }
  }

  .dai {
    background-color: #29d894;
  }

  .back {
    background-color: #ff9797;
  }

  .promote {
    background-color: #8bb8f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue